//const BASE_URL = 'http://localhost:3000/';
// const BASE_URL = 'http://10.0.2.2:5000/';


//const BASE_URL = 'http://192.168.2.8:5000/';
//const BASE_URL = 'http://0.0.0.0:5000/';
const BASE_URL = 'https://localfood-badwaldsee.de'
export { BASE_URL };
